<template>
  <main id="aboutusMainContainer">
    <div class="container-fluid px-0">
      <b-row>
        <b-col cols="12">
          <div class="custom_page_header">
            <h2>{{$t('message.experly_structured')}}</h2>
            <p class="lead">{{$t('message.effective_sol')}}</p>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-row class="pt-3 justify-content-center" id="aboutusMain">
        <b-col cols="12">
            <p>{{$t(`message.ourcom`)}}</p>
            <p>{{$t(`message.weddoffer`)}}</p>
            <p>{{$t(`message.multiple_cases`)}}</p>
        </b-col>
        <b-col cols="12" class="pt-2">
            <h3 class="text-center">{{$t(`message.trdistchannel`)}}</h3>
            <p class="lead text-center">{{$t(`message.trdistthrough`)}}</p>
            <b-list-group class="text-center listb2b">
              <b-list-group-item class="font-600">B2B Platform</b-list-group-item>
              <b-list-group-item class="font-600">API</b-list-group-item>
              <b-list-group-item class="font-600">Direct</b-list-group-item>
            </b-list-group>
        </b-col>
    </b-row>
    <b-row class="pt-2">
        <b-col cols="12">
            <h3 class="text-center ourTeam">{{$t(`message.wawmyactot`)}}</h3>
        </b-col>            
    </b-row>
    <card-advance-profile />
    
  </main>
</template>

<script>
import {
  BRow, BCol, BListGroup, BListGroupItem
} from 'bootstrap-vue'
import CardAdvanceProfile from '../card/card-advance/CardAdvanceProfile.vue'
export default {
  components: {
    BRow,
    BCol,
    CardAdvanceProfile,
    BListGroup,
    BListGroupItem
  },
  metaInfo: {
    title: 'About Us | Safetravel.today - Making Travel Insurance Easy',
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { 
        name: 'description', 
        content: 'Learn more about Safetravel.today, the travel insurance platform dedicated to safe and secure journeys. Discover our mission, values, and team.' 
      },
      { 
        name: 'keywords', 
        content: 'about Safetravel.today, travel insurance company, who we are, travel safety mission, secure trips' 
      },
      { property: 'og:title', content: 'About Safetravel.today - Your Travel Insurance Partner' },
      { property: 'og:description', content: 'Safetravel.today provides reliable travel insurance solutions. Learn about our mission, vision, and commitment to safe travels.' },
      { property: 'og:image', content: 'https://safetravel.today/images/about.png' },
      { property: 'og:type', content: 'website' },
      { name: 'robots', content: 'index, follow' },
    ],
    script: [
      {
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Safetravel.today',
          url: 'https://safetravel.today',
          logo: 'https://safetravel.today/logo.png',
          sameAs: [
            'https://www.facebook.com/safetraveltoday',
            'https://www.linkedin.com/company/safe-travel',
            'https://x.com/safetraveltoday'
          ],
          description: 'Safetravel.today is a travel insurance company offering secure, flexible, and affordable coverage for safe journeys worldwide.'
        },
      },
    ],
  },
}
</script>
<style scoped>
  .listb2b > .list-group-item{
    color: var(--foreground-color);
  }
  .ourTeam {
    color: var(--accent3-color);
    font-weight: 600;
  }
</style>